export const slugify = (str: string) => {
	return str
		.toLowerCase()
		.replace(/\s+/g, '-')
		.replace(/[^a-z0-9\-]/g, '');
};

export const deslugify = (slug: string) => {
	return slug.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
};
